export const INTEGRATED_SCAC_CODES: { code: string; name: string }[] = [
  {code: 'OOLU', name: 'OOCL'},
  {code: 'COSU', name: 'COSCO'},
  {code: 'MSCU', name: 'MSC'},
  {code: 'MAEU', name: 'Maersk'},
  {code: 'ONEY', name: 'ONE'},
  {code: 'YMLU', name: 'Yang Ming'},
  {code: 'CMAU', name: 'CMA CGM'},
  {code: 'ZIMU', name: 'ZIM'},
  {code: 'HLCU', name: 'Hapag-Lloyd'},
];
